import { StoreState } from '../reducers/rootReducer/rootReducer';

export function getEmail(state: StoreState) {
  return state.userInformation.email;
}

export function getUsername(state: StoreState) {
  return state.userInformation.username;
}
